import { PreloaderScreen } from '../../gameClient/webgl/preloaderScreen';
import { PreloaderBackgroundType } from '../../constants/PreloaderBackgroundType';

type SetPreloaderBackgroundParams = {
    linkage: PreloaderBackgroundType
}

export class SetPreloaderBackground {
    public handle(params: SetPreloaderBackgroundParams): void {
        PreloaderScreen.getInstance().setBackground(params.linkage);
    }
}
